module.exports = __webpack_public_path__ + "static/fonts/open-sans-v34-latin-600.603c9927.woff2";